import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';

const RangeValue = ({ rule, onValueChange, disabled }) => {
  let parsed = {};
  // Prefer parsing the stored JSON string if present
  if (typeof rule.value === 'string' && rule.value) {
    try {
      parsed = JSON.parse(rule.value);
    } catch (e) {
      parsed = {};
    }
  } else if (rule && (rule.min !== undefined || rule.max !== undefined)) {
    // Fallback: some fields have parsed value merged to top-level (min/max)
    parsed = {
      ...(rule.min !== undefined ? { min: rule.min } : {}),
      ...(rule.max !== undefined ? { max: rule.max } : {}),
    };
  } else {
    parsed = rule.value || {};
  }

  const { min = '', max = '' } = parsed || {};

  const [localMin, setLocalMin] = useState(min);
  const [localMax, setLocalMax] = useState(max);

  const handleMinChange = (e, data) => {
    setLocalMin(data.value);
    const newValue = { ...parsed, min: data.value };
    onValueChange(rule.instanceId, JSON.stringify(newValue));
  };

  const handleMaxChange = (e, data) => {
    setLocalMax(data.value);
    const newValue = { ...parsed, max: data.value };
    onValueChange(rule.instanceId, JSON.stringify(newValue));
  };

  const isDisabled = disabled !== undefined ? disabled : !rule.enabled;

  // Determine presence of min/max keys. If a key is explicitly undefined or null it's considered absent.
  const hasMin = parsed && parsed.min !== undefined && parsed.min !== null;
  const hasMax = parsed && parsed.max !== undefined && parsed.max !== null;

  const minNum = parseFloat(localMin);
  const maxNum = parseFloat(localMax);
  const isInvalid = !Number.isNaN(minNum) && !Number.isNaN(maxNum) && minNum > maxNum;

  return (
    <div className='range-inputs' data-testid={`range-inputs-${rule.id}`}>
      <div className='range-inputs-row'>
        {hasMin && (
          <Input
            type='number'
            value={localMin}
            onChange={handleMinChange}
            disabled={isDisabled}
            error={isInvalid}
          />
        )}

        {hasMin && hasMax && <span className='range-separator'>—</span>}

        {hasMax && (
          <Input
            type='number'
            value={localMax}
            onChange={handleMaxChange}
            disabled={isDisabled}
            error={isInvalid}
          />
        )}
      </div>
      {isInvalid && (
        <span className='range-error' data-testid={`range-error-${rule.id}`}>
          Min cannot be greater than Max
        </span>
      )}
    </div>
  );
};

RangeValue.propTypes = {
  rule: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default RangeValue;
